import Partenaires from "./Partenaires";
export default Partenaires;
